// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"726":"9a78eb73","895":"9a78eb73","2247":"92baae7a","4050":"c723d8a7","7632":"ef42b274","8495":"ef42b274"}[chunkId] + ".chunk.css";
};